module.exports = __webpack_public_path__ + "img/qg3_11.5408e773.png";